"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _marketing = require("@/api/marketing");

var _permission = require("@/utils/permission");

var _edit = _interopRequireDefault(require("./edit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import systemStore from './addPoint';
// 权限判断函数
var _default = {
  name: 'activity',
  // components: { systemStore },
  components: {
    addClerkList: _edit.default
  },
  data: function data() {
    return {
      artFrom: {
        page: 1,
        limit: 20,
        status: '1',
        keywords: ''
      },
      loading: false,
      tableData: [],
      total: 0,
      headerCount: {},
      editDialogConfig: {
        visible: false,
        data: {},
        isEdit: 0 // 0=add 1=edit

      }
    };
  },
  created: function created() {
    // this.storeGetCount();
    this.tableList();
  },
  methods: {
    //表格列表
    tableList: function tableList() {
      var that = this;
      that.loading = true;
      (0, _marketing.activityListApi)(that.artFrom).then(function (res) {
        that.loading = false;
        that.tableData = res.list;
        that.total = res.total;
      });
    },
    //切换页数
    pageChange: function pageChange(index) {
      this.artFrom.page = index;
      this.tableList();
    },
    //切换显示条数
    sizeChange: function sizeChange(index) {
      this.artFrom.limit = index;
      this.tableList();
    },
    //头部切换
    onClickTab: function onClickTab() {
      this.artFrom.keywords = '';
      this.tableList();
    },
    //搜索
    search: function search() {
      this.artFrom.page = 1;
      this.tableList();
    },
    allDelete: function allDelete(id) {
      var _this = this;

      this.$modalSure().then(function () {
        allDeleteApi({
          id: id
        }).then(function () {
          _this.$message.success('删除成功');

          _this.storeGetCount();

          _this.tableList();
        });
      });
    },
    //添加
    add: function add() {
      this.$refs.template.dialogFormVisible = true;
    },
    //编辑
    // edit(id) {
    //   this.$refs.template.dialogFormVisible = true;
    //   this.$refs.template.getInfo(id);
    // }
    edit: function edit(id) {
      this.$refs.template.dialogFormVisible = true;
      this.$refs.template.getInfo(id);
    },
    handlerHideDialog: function handlerHideDialog() {
      this.tableList();
      this.editDialogConfig.visible = false;
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this2 = this;

      console.log("rowData", rowData);
      this.$confirm("确定删除当前数据", "提示").then(function (result) {
        (0, _marketing.DelActivity)(rowData).then(function (data) {
          _this2.$message.success("删除数据成功");

          _this2.tableList();
        });
      });
    }
  }
};
exports.default = _default;